'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _immutable = require('immutable');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeisPublicationController = function FeisPublicationController(feis, fFeisService) {
  var _this = this;

  _classCallCheck(this, FeisPublicationController);

  this._ = {
    fFeisService: fFeisService
  };
  this.feis = feis;
  this.isPublic = this.feis.is_public === 1;

  this.togglePublish = function () {
    if (_this.isPublic) {
      _this._.fFeisService.publish(_this.feis.id);
      _this.feis.is_public = 1;
    } else {
      _this._.fFeisService.unpublish(_this.feis.id);
      _this.feis.is_public = 0;
    }
  };
};

exports.default = _angular2.default.module('ifeis.routes.feiseanna.one.admin.publish', ['ngMaterial', 'ui.router', 'ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.publish', {
    url: '/publish',
    template: require('./tpl.html'),
    controller: FeisPublicationController,
    controllerAs: 'publish',
    ncyBreadcrumb: {
      label: 'Publication Settings',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/publish/index.js
// module id = 554
// module chunks = 0